import { Component,OnInit, Input, ViewChild, ElementRef, Output } from '@angular/core';
import { DataModel } from '../../../../models/data.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { Subject } from 'rxjs';


interface IProdutoAdicionais{
    id?:String;
    codproduto?:String;
    texto:String;
    precoVenda?:Number;    
}



class ProdutoAdicionaisDataModel extends DataModel<IProdutoAdicionais>{

}


@Component({
    selector: 'produto-adicionais',
    templateUrl: 'produto-adicionais.html'
})

export class ProdutoAdicionaisControl implements OnInit {
    fItemProduto:any;
    produtoId:String;
    items:IProdutoAdicionais[];
    collection:string;
    dataModel : ProdutoAdicionaisDataModel; 
    item:any ={};
    editing: boolean = false;
    colunas = [
        { field: 'codigoProduto', text: "Código Produto", width:13 },
        { field: 'texto', text: "Descrição", width:120 },
        { field: 'precoVenda', text: "Preco Venda", width:18 },
    ];
    @ViewChild("grid") grid: ElementRef<MatDataGridComponent>;

    
   @Output()
   change = new Subject<any[]>();

    @Input()
    get value(){
        return this.fItemProduto;
    }
    set value(x){
        this.fItemProduto = x;
        this.produtoId = x.id;
        console.log(this.produtoId);
        this.carregarComplemento(this.produtoId);

    };

    constructor(private db:AngularFirestore) {


     }

    ngOnInit() { }

    carregarComplemento(id:String){
        this.collection = 'nc-produtos/' + id + '/adicionais'
        this.dataModel =   new ProdutoAdicionaisDataModel(this.db,'');
        this.dataModel.collectionName(this.collection);      
        this.dataModel.snapshot(null,(rsp)=>{
         this.items = rsp;
         if (this.change) this.change.next(rsp);
       })
    }


    doEditItemCompl( ds ){
        console.log(ds);
        if (ds.state=="dsInsert"){
           this.item = {}
        } else {
            this.item = ds.values;
        }
        this.editing = true;
    }

    salvarItemCompl(item){
      item.precoVenda = parseFloat(item.precoVenda.toString());  
      this.dataModel.post(item);   
      this.editing = false;

    }
    cancelarItemCompl(){
      this.editing =false;
    }

    doDeleteItemCompl(item){
      this.dataModel.deleteRow(item.id);   
      this.editing =false;
    }



}